<template>
    <div class="bg-white" style="background-image: url('/images/home/stats-cloud.png');" :style="{
        backgroundPosition: 'top center',
        backgroundSize: '100%',
        backgroundRepeat: 'no-repeat',
        paddingTop: '8rem',
        paddingBottom: '6.5rem'
    }">
        <div class="mx-auto max-w-7xl px-6 lg:px-8">
            <dl class="grid grid-cols-1 gap-x-8 gap-y-16 text-center lg:grid-cols-3">
                <div v-for="stat in stats" :key="stat.id" class="mx-auto flex max-w-xs flex-col gap-y-4">
                    <dt class="text-base/7 text-teal-900">{{ stat.name }}</dt>
                    <dd class="order-first text-3xl font-semibold tracking-tight text-teal-900 sm:text-5xl">{{
                        stat.value }}</dd>
                </div>
            </dl>
        </div>
    </div>
</template>

<script setup>
const stats = [
    { id: 0, name: 'Students enrolled', value: '+ 1M' },
    { id: 1, name: 'Courses available', value: '+ 500' },
    { id: 3, name: 'Languages supported', value: '5' },
]
</script>
